import React from 'react';
import InviteCard from '../invitation/InviteCard';
import MessageContent from './MessageContent';

interface MessageProcessorProps {
  content: string;
}

// Matches erozion.net/CODE and app.erozion.com/invite/CODE invite links.
const INVITE_PATTERN = /(https?:\/\/)?(?:erozion\.net\/([a-zA-Z0-9]{3,})|app\.erozion\.com\/invite\/([a-zA-Z0-9]{3,}))(?![a-zA-Z0-9/])/g;

const MessageProcessor: React.FC<MessageProcessorProps> = ({ content }) => {
  const parts: Array<{ type: 'text'; content: string } | { type: 'invite'; code: string }> = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  const re = new RegExp(INVITE_PATTERN.source, 'g');

  while ((match = re.exec(content)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: 'text', content: content.substring(lastIndex, match.index) });
    }
    const inviteCode = match[2] || match[3];
    if (!inviteCode) continue;
    parts.push({ type: 'invite', code: inviteCode });
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < content.length) {
    parts.push({ type: 'text', content: content.substring(lastIndex) });
  }
  // No invite links found — just render as normal message
  if (parts.length === 0 || (parts.length === 1 && parts[0].type === 'text')) {
    return <MessageContent content={content} />;
  }

  return (
    <div className="space-y-0.5">
      {parts.map((part, i) => {
        if (part.type === 'invite') {
          return <InviteCard key={`inv-${i}`} inviteCode={part.code} inMessage />;
        }
        // Non-empty text segments rendered with full mention + markdown support
        if (part.content.trim()) {
          return <MessageContent key={`txt-${i}`} content={part.content} />;
        }
        return null;
      })}
    </div>
  );
};

export default MessageProcessor;
